import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {

  constructor() {
   
   }
  public get title() {
    return 'App Menu2';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
  public localhost() {
    return isDevMode();
  }
}
